import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49cefe03"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inputAndCorrection" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { key: 0 }

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  should: { type: Number },
  show: { type: Boolean, default: false },
},
  emits: ["update", "tab"],
  setup(__props, { expose, emit: emits }: { emit: ({
  (e: "update", v: number | null): void;
  (e: "tab"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props





const inputDigit = ref("");
const inputElement = ref(null as null | HTMLInputElement);

function handleKeydownInput(id: number, ev: KeyboardEvent) {
  ev.preventDefault();
  if (props.show) return;

  if (ev.key === "Delete" || ev.key === "Backspace") {
    inputDigit.value = "";
    emits("update", null);
    return;
  }

  if (ev.key === "Tab") {
    emits("tab");
  }

  const digit = parseInt(ev.key);
  if (isNaN(digit)) return;

  inputDigit.value = ev.key;
  emits("update", digit);
}

function clear() {
  inputDigit.value = "";
  emits("update", null);
}

function focus() {
  inputElement.value?.focus();
}

expose({ clear, focus });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("input", {
      type: "number",
      min: "0",
      max: "9",
      step: "0",
      ref_key: "inputElement",
      ref: inputElement,
      class: _normalizeClass({
        digitInput: true,
        finishedTest: __props.show,
        correct: __props.show && String(props.should) === inputDigit.value,
      }),
      value: inputDigit.value,
      onKeydown: _cache[0] || (_cache[0] = (ev) => handleKeydownInput(1, ev))
    }, null, 42, _hoisted_2),
    (props.should !== undefined && props.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(props.should), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})